<template>
  <b-modal title="Abastecimentos" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE ABASTECIMENTO :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getAbastecimentos" :fields="fields.abastecimento">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(valor)="data">
          <div>
            <p>{{ formatter.format(data.item.valor) }}</p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <abastecimento-edit-modal ref="abastecimentoEdit" @update="update()" />
    <confirm-modal
      ref="confirmDelAbastecimento"
      :descricao="'Deseja realmente remover o abastecimento ?'"
      @executar="executar()"
    />

    <template #modal-footer>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { VMoney } from "v-money";
import { useVeiculoStore } from "@/stores/VeiculoStore";
import TableFields from "@/tools/TableFields";
import Veiculo from "@/models/Veiculo";
import Abastecimento from "@/models/Abastecimento";
import AbastecimentoModal from "@/components/modals/transporte/AbastecimentoModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";

export default {
  name: "AbastecimentoListModal",

  components: {
    "abastecimento-edit-modal": AbastecimentoModal,
    "confirm-modal": ConfirmModal,
  },

  directives: { money: VMoney },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      veiculo: new Veiculo(0, "Novo Transporte", "", "", "", "", ""),
      abastecimento: new Abastecimento(0, new Date(), "", "Gasolina - Ethanol - Diesel - GNV", 0, 0, ""),
      abastecimentos: [],
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
    };
  },

  methods: {
    editar(abastecimento) {
      abastecimento.veiculo = this.veiculo;
      this.$refs.abastecimentoEdit.call(abastecimento);
    },

    adicionar() {
      let abastecimento = new Abastecimento(0, new Date(), "", "Gasolina - Ethanol - Diesel - GNV", 0, 0, "");
      abastecimento.veiculo = this.veiculo;
      this.$refs.abastecimentoEdit.call(abastecimento);
    },

    deletar(abastecimento) {
      this.abastecimento.update(abastecimento);
      this.$refs.confirmDelAbastecimento.call();
    },

    executar() {
      this.veiculoStore.REMOVER_ABASTECIMENTO(this.abastecimento.id).then(() => {
        this.update();
      });
    },

    update() {
      this.veiculoStore.LISTAR_ABASTECIMENTOS(this.veiculo.id).then(() => {
        this.abastecimento = new Abastecimento(0, new Date(), "", "Gasolina - Ethanol - Diesel - GNV", 0, 0, "");
        this.abastecimentos = this.getAbastecimentos;
      });
    },

    call(veiculo) {
      this.show = !this.show;
      this.veiculo = veiculo;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const veiculoStore = useVeiculoStore();
    const { getAbastecimentos } = storeToRefs(veiculoStore);

    return {
      store,
      veiculoStore,
      getAbastecimentos,
    };
  },
};
</script>

<style lang="scss" scoped></style>
